export var MuiChip = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return {
        fontSize: theme.typography.caption.fontSize,
        "& .MuiSvgIcon-root": {
          marginLeft: theme.spacing(1)
        },
        "& .MuiSvgIcon-root + .MuiChip-label": {
          paddingLeft: theme.spacing(.5)
        },
        "&.MuiChip-filledDefault": {
          background: theme.palette.grey[200],
          color: theme.palette.text.primary,
          borderRadius: '.5rem',
          fontWeight: 500
        },
        "&.MuiChip-filledInfo": {
          background: theme.palette.info.light,
          color: theme.palette.info.dark,
          borderRadius: '.5rem',
          fontWeight: 500
        },
        "&.MuiChip-filledError": {
          background: theme.palette.error.light,
          color: theme.palette.error.dark,
          borderRadius: '.5rem',
          fontWeight: 500
        },
        "&.MuiChip-filledSuccess": {
          background: theme.palette.success.light,
          color: theme.palette.success.dark,
          borderRadius: '.5rem',
          fontWeight: 500
        },
        "&.MuiChip-filledWarning": {
          background: theme.palette.warning.light,
          color: theme.palette.warning.dark,
          borderRadius: '.5rem',
          fontWeight: 500
        }
      };
    }
  }
};
//# sourceMappingURL=MuiChip.js.map